{
    "AddNotification": "Melding toevoegen",
    "EditNotification": "Bewerk melding",
    "EnableNotification": "Melding inschakelen",
    "DisableNotification": "Melding uitschakelen",
    "NotificationNameBusyTime": "Drukke tijd",
    "NotificationNameAvgAnswerTime": "Gemiddelde antwoordtijd (seconden)",
    "NotificationNameUserNotLoggedIn7Days": "Gebruiker 7 dagen niet ingelogd",
    "NotificationNameMissedCalls": "Gemiste gesprekken (#)",
    "NotificationNameUserNeverLoggedIn": "Nooit ingelogd",
    "NotificationNameWeeklyInsightsReport": "Wekelijks inzichtenrapport",
    "NAME": "NotificationsLanguage"
}